<script lang="ts" setup>
import { computed, inject, ref, watch } from 'vue'
import { FireRiskDashboardViewModel } from '../../viewmodels/FireRiskDashboard.viewmodel'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import BaseTable from '../../../../ui/components/baseTable/BaseTable.vue'
import FireOutbreakCardReactionMenu from '../FireOutbreakCardReactionMenu.vue'
import SFButton from '@/components/ui/button/Button.vue'
import FireAlertsFilter from '../FireAlertsFilter.vue'
import EmptyState from '@/@web/ui/components/EmptyState.vue'
import { useTable } from '../../../../ui/components/baseTable/composables/Table.composable'
import { FireAlertsTableHeadersFactory } from '../../factories/FireAlertsTableHeaders.factory'

const vm = inject<FireRiskDashboardViewModel>('fire-risk-dashboard-viewmodel')!

const rerender = ref(Math.random())

const {
	pageData: alerts,
	page: alertsPage,
	pageSize: alertsPageSize,
	onPageChange: alertsOnPageChange,
	sortOptions,
	handleSort,
} = useTable(vm.filteredFireOutbreakAlerts)

const tableHeaders = computed(() => [...FireAlertsTableHeadersFactory.make(sortOptions.value)])

watch(vm.mapFireOutbreaks, () => (rerender.value = Math.random()), { deep: true })

watch(
	vm.selectedFarmsIds,
	() => {
		vm.getRecentFireRisks()
		vm.getRecentFireOutbreaks()
	},
	{ immediate: true },
)

watch([() => vm.fireAlertsFilter.value.startDate, () => vm.fireAlertsFilter.value.endData], () =>
	vm.getRecentFireOutbreaks(),
)
</script>

<template>
	<div class="p-4">
		<div
			style="display: flex"
			class="mb-8 justify-between items-center"
		>
			<h4 class="text-default-bold !text-blue-base">Registro de Focos de Incêndio</h4>
			<div
				style="display: flex"
				class="flex gap-2 !w-fit justify-end"
			>
				<s-f-button
					text="exportar"
					secondary
					@click="vm.exportDataTable()"
					:disabled="vm.fireOutbreakAlerts.value?.length === 0"
				/>
				<fire-alerts-filter :disabled="vm.fireOutbreakAlerts.value?.length === 0" />
			</div>
		</div>
		<div v-if="alerts?.length">
			<base-table
				:colunas="tableHeaders"
				:data="alerts"
				display-mode
				:key="rerender"
				@sort="handleSort($event)"
			>
				<template #reaction="dado">
					<div
						style="display: flex"
						class="justify-center"
					>
						<fire-outbreak-card-reaction-menu
							class="absolute"
							:paint-icon="false"
							:alert="{ ...dado }"
							@reaction="(value) => vm.rateFireOutbreak(value, dado.id)"
						/>
					</div>
				</template>
			</base-table>
			<pagination
				v-if="alerts?.length"
				class="mt-8"
				:key="vm.filteredFireOutbreakAlerts.value?.length"
				:total="vm.filteredFireOutbreakAlerts.value?.length"
				:page="alertsPage"
				:page-size="alertsPageSize"
				@paginationSettings="alertsOnPageChange"
			/>
		</div>
		<empty-state
			v-else-if="vm.hasActiveFilter.value"
			icon="tabler:search"
			title="Nenhum resultado encontrado para o filtro aplicado"
			subtitle="Tente usar outras combinações para obter melhores resultados."
			clearable
			@clear="vm.clearFilter()"
		/>
		<empty-state
			v-else
			title="Nenhum registro encontrado"
			subtitle="Aguarde a notificação dos alertas para visualizar os registros."
		/>
	</div>
</template>
